// extracted by mini-css-extract-plugin
export default {"container":"GK-z","topReviewHeading":"HK-z","criticalReview":"IK-z","favorableReview":"JK-z","vsSeparator":"KK-z"};